import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { dismissedAfterFirstMediaCaptureDialog } from "src/modules/activity-log/duck/actions";

import VerticalDialog from "src/components/VerticalDialog";
import getImageSrc from "src/utils/getImageSrc";

export default function AfterFirstMediaCaptureDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <VerticalDialog
      imageSrc={getImageSrc("first-save.svg")}
      buttonBottom={{
        onClick: () => {
          dispatch(dismissedAfterFirstMediaCaptureDialog());
          onDismiss();
        },
        text: t("buttons.ok")
      }}
      heading={t("activityLog.afterFirstMediaCaptureDialog.heading")}
      text={t("activityLog.afterFirstMediaCaptureDialog.text")}
      isOpen={isOpen}
    />
  );
}
